import { createContext, RefObject } from 'react'
import { BlickTVContextTrackingDispatchProps } from '@widgets/Video/types/darkcove'

export interface BlickTVContextType {
  playerRef: RefObject<any | null>
  popOut: () => void
  popIn: () => void
  isFloating: () => boolean
  setDispatchTrackingEvents: (
    arg: (props: BlickTVContextTrackingDispatchProps) => void
  ) => void
  setBlickTVCleanupFunction: (arg: () => void) => void
  setBlickTVPlayerId: (id: string) => void
  isPoppedOut: boolean
  hasPortalNode: boolean
  portalNode: any
  hasPlayer: boolean
  headlineBlickTV: string
  changeHeadlineBlickTV: (newHeadline: string) => void
  addPlayer: (playerComponent: any, refOfPlayer: any) => void
  unmount: () => void
  preventAutoMount: boolean
  stopLivePlayback: () => void
  resumeLivePlayback: () => void
  changeNewstickerAdVisibility: (visible: boolean) => void
  setAllowPopOutFunction: (ruleFunction: () => boolean) => void
}

const BlickTVContext = createContext<BlickTVContextType>({
  playerRef: { current: null },
  popOut: () => {},
  popIn: () => {},
  isFloating: () => false,
  setDispatchTrackingEvents: () => {},
  setBlickTVCleanupFunction: () => {},

  setBlickTVPlayerId: () => {},
  isPoppedOut: false,
  hasPortalNode: false,
  portalNode: null,
  hasPlayer: false,
  headlineBlickTV: '',
  changeHeadlineBlickTV: () => {},
  addPlayer: () => {},
  unmount: () => {},
  preventAutoMount: false,
  stopLivePlayback: () => {},
  resumeLivePlayback: () => {},
  changeNewstickerAdVisibility: () => {},
  setAllowPopOutFunction: () => {},
})

const exports = { BlickTVContext }

export default exports
